export default __webpack_public_path__ + "f1f6f888ce2d8906ebb5d54d7d23cad0.png";